module.exports = __webpack_public_path__ + "assets/img/3.3d6289c2.jpg";